module.exports = __webpack_public_path__ + "img/logo-mini-white-rounded.213c5e53.svg";